export default __webpack_public_path__ + "4faab6314896a1ac1e0d304791eda7fd.svg";